import Vue from 'vue';
import { Getter, Mutation, State } from 'vuex-simple';
import { uuid } from '@/Common/Utils/General/Modules/data';
import { $bus } from '@/HostApp/services/Bus';
import { HttpServiceEvents } from '@/HostApp/services/HttpService/Error/ResponseError';

export enum MessageType {
	Info = 'info',
	Error = 'error',
	Success = 'success',
	Warning = 'warning'
}

export type TAlertMessageBody = string | { description: string } | { message: string };

export class AlertServiceModule {
	constructor() {
		$bus.$on(HttpServiceEvents.ERROR, (response: TRA.IResponse<TAlertMessageBody>) => {
			const { data } = response;
			this.addMessage([{} as APS.IAlertMessageContext, data, 'error']);
		});
	}

	@State()
	protected messages: Common.IMap<Array<APS.IAlertMessage>> = {};

	protected mapMessageType(value: string): MessageType {
		switch (value) {
			case 'update':
			case 'success':
				return MessageType.Success;
			case 'info':
			case 'progress':
			case 'devel-error':
				return MessageType.Info;
			case 'limits':
			case 'warning':
				return MessageType.Warning;
			default:
				return MessageType.Error;
		}
	}

	@Mutation()
	addMessage(message: [APS.IAlertMessageContext, TAlertMessageBody, string]): void {
		const indexOfMessageType = 2;
		const type = this.mapMessageType(message[indexOfMessageType]);
		const id = message[0]?.id || this.currentApplication;

		!this.messages[id] && Vue.set(this.messages, id, []);

		this.messages[id].push({
			type,
			context: message[0],
			details: this.extractMessageBody(message[1]),
			id: uuid.v4()
		});
	}

	protected extractMessageBody(message: TAlertMessageBody): string {
		if (typeof message === 'string') {
			return message;
		} else if ('description' in message) {
			return message.description;
		} else if ('message' in message) {
			return message.message;
		} else {
			return '';
		}
	}

	@Mutation()
	removeAllMessages(): void {
		Vue.set(this.messages, this.currentApplication, []);
	}

	@Mutation()
	removeMessage(idx: number): void {
		this.messages[this.currentApplication].splice(idx, 1);
	}

	@Getter()
	public get currentApplicationMessages(): Array<APS.IAlertMessage> {
		return this.messages[this.currentApplication] || [];
	}

	@Getter()
	protected get currentApplication(): string {
		return window.aps.context._view.id;
	}
}

const alertServiceModule = new AlertServiceModule();

export default alertServiceModule;
